import { Box, Button, Typography, styled, Link as MuiLink } from '@mui/material'
import { InvoiceCloudFrame, MButton, ProgressLoaders, Text } from 'components'
import { USER_TOKEN } from 'config'
import { ROUTES_PATH } from 'config/routes'
import { useAuth } from 'context'
import dayjs from 'dayjs'
import type React from 'react'
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { formatValue, useLocalStorage } from 'utils'
import { useMobileBreakpoints } from 'utils/hooks/useMobileBreakpoints'
import PaymentPlanIcon from '@mui/icons-material/RequestQuote'

export const Bill: React.FC = () => {
  const { account, currentAccount, getAccount, isAdmin, userEmail } = useAuth()
  const isMobile = useMobileBreakpoints()
  const [authToken] = useLocalStorage(USER_TOKEN, '')
  const [prevAccountId, setPrevAccountId] = useState<string>('')

  useEffect(() => {
    if (prevAccountId === currentAccount?.accountId || currentAccount?.accountId === account?.myAccount?.accountId) {
      return
    }
    if (currentAccount?.accountId !== null) {
      void getAccount({
        AccessToken: authToken,
        accountId: currentAccount?.accountId,
        admin: isAdmin,
        email: userEmail
      })
    }
    setPrevAccountId((currentAccount?.accountId ?? account?.myAccount?.accountId) ?? '')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authToken, currentAccount])
  return (
    <>
      {account !== null
        ? <Wrapper height="100%">
          <Box px={3} py={5}>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              pb={3}
            >
              <Box display="flex" flexDirection="column" gap={1}>
                <Text color="#000000" fontSize="18px" fontWeight="600">
                  Power Bill
                </Text>
                <Text color="#5D6365" fontSize="12px">
                  Account Number: {account?.myAccount.accountId}
                </Text>
              </Box>
              {!isMobile && <Box display="flex">
                <InvoiceCloudFrame page={1}>
                  <MButton variant="text" texttransform="none">
                    <Text color="#1513C3" fontSize="16px" align="right">
                      Pay Bill
                    </Text>
                  </MButton>
                </InvoiceCloudFrame>
                <Link to={ROUTES_PATH.BILLING}>
                  <MButton variant="text" texttransform="none">
                    <Text color="#1513C3" fontSize="16px" align="right">
                      View Details
                    </Text>
                  </MButton>
                </Link>
              </Box>}
            </Box>
            <Box flexDirection={isMobile ? 'column' : 'row'} display="flex">
              <Box flex={1} display="flex" flexDirection="column" gap={1} pt={2} pb={3} borderBottom={isMobile ? 'solid 2px #EFEFFA' : '0'}>
                <Typography color="#010B0E" fontSize={12} letterSpacing={2}>
                  DETAILS
                </Typography>
                <Box display="flex" flexDirection={isMobile ? 'row' : 'column'} justifyContent="space-between" alignItems={isMobile ? 'center' : 'left'}>
                  <Typography color="#5D6365" fontSize={12}>
                    Previous Balance:
                  </Typography>
                  <Typography color="#010B0E" fontWeight={600} fontSize={18}>
                    {((account?.myAccount?.previousBalance) != null) && formatValue(account?.myAccount?.previousBalance, true, true, true)}
                  </Typography>
                </Box>
                <Box display="flex" flexDirection={isMobile ? 'row' : 'column'} justifyContent="space-between" alignItems={isMobile ? 'center' : 'left'}>
                  <Typography color="#5D6365" fontSize={12}>
                    Late Payment/Penalty Charges:
                  </Typography>
                  <Typography color="error" fontWeight={600} fontSize={18}>
                    {((account?.myAccount?.lateFees) != null) && formatValue(account?.myAccount?.lateFees)}
                  </Typography>
                </Box>
              </Box>
              <Box flex={1} display="flex" flexDirection="column" pt={isMobile ? 2 : 0} >
                <Box display="flex" flexDirection={isMobile ? 'row' : 'column'} justifyContent="space-between" mb={2}>
                  <Typography color="#010B0E" fontSize={12} letterSpacing={2}>
                    BALANCE DUE
                  </Typography>
                  <Typography color="#5D6365" fontSize={12}>
                    Due Date:{' '}
                    {((account?.myAccount?.dueDate) != null) && dayjs(account?.myAccount?.dueDate).format('MMM D, YYYY')}
                  </Typography>
                </Box>
                <Box borderRadius={1} border="solid 1px #D3D4F0">
                  <Typography fontSize={isMobile ? '30px' : '52px'} bgcolor="#F9F9FD" py={1} width="100%" textAlign="center">
                    {((account?.myAccount?.accountBalance) != null) && formatValue(account?.myAccount?.accountBalance, true, true, true)}
                  </Typography>
                  <Box display="flex" flexDirection="row" p="10px" gap="10px" alignItems="center" bgcolor="#EFEFFA">
                    <PaymentPlanIcon sx={{ color: '#8387D6', background: '#E5E5F6', borderRadius: '30px', padding: '6px' }} />
                    <Typography color="#5D6365" fontSize={isMobile ? '12px' : '16px'}> Need a Payment Plan? Contact us at <MuiLink sx={{ textDecoration: 'none' }} href='tel:8444250855'>844-425-0855</MuiLink></Typography>
                  </Box>
                </Box>
              </Box>
              {isMobile && <Box mt={3}>
                <InvoiceCloudFrame page={1}>
                  <Button size='small' fullWidth variant="contained" sx={{ borderRadius: 10, paddingY: 2, fontSize: 16, textTransform: 'none', boxShadow: 0 }}>
                    Pay Bill
                  </Button>
                </InvoiceCloudFrame>
                <Link to={ROUTES_PATH.BILLING}>
                  <Button size='small' fullWidth variant="outlined" sx={{ borderRadius: 10, paddingY: 2, fontSize: 16, textTransform: 'none', boxShadow: 0, marginTop: 2 }}>
                    View Details
                  </Button>
                </Link>
              </Box>}
            </Box>
          </Box>
        </Wrapper>
        : <ProgressLoaders height='100%' />}
    </>
  )
}

const Wrapper = styled(Box)({
  background: '#ffffff',
  borderRadius: '4px'
})
